import React from 'react';
import { useStore } from '../../State';
import { Link } from './styled/Text';
import EmailLink from './EmailLink';

type Props = {
  lowerCase?: boolean;
};

const SupportDetails = ({ lowerCase }: Props) => {
  const { config } = useStore();
  const email = config.getSupportEmail();
  const phone = config.getSupportPhone();
  return (
    <span>
      {lowerCase ? 'p' : 'P'}lease contact <EmailLink>{email}</EmailLink>{' '}
      {phone && (
        <>
          or call <Link href={`tel:${phone}`}>{phone}</Link>{' '}
        </>
      )}
      for further assistance.
    </span>
  );
};
SupportDetails.defaultProps = {
  lowerCase: false,
};

export default SupportDetails;
